import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_authed/_admin/birthdays")({
  component: BirthdaysLayout,
})

function BirthdaysLayout() {
  return <Outlet />
}
